import gql from 'graphql-tag'

export const UPDATE = gql`
mutation(
    $reuseId: ID!
    $name: String!
    $type: String!
    $laoName: String
    $score:Int
  ){
    updateReuse( info:{
      reuseId: $reuseId
      name: $name
      type: $type
      laoName:$laoName
      score:$score
    }
    ){
      _id
      name
    }
  }
`

